import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: (p) => p.spacing(1),
  width: '100%',
};

export const card: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(0.5),
  width: '100%',
};

export const scrollbar: SxStyle = {
  height: (p) => p.spacing(22),
};

export const item: SxStyleFunc<boolean> = (hovered) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(0.5),
  borderRadius: (p) => p.spacing(0.5),
  backgroundColor: hovered ? (p) => p.palette.grey[200] : 'transparent',
});

export const label: SxStyle = {
  overflow: 'hidden',
  width: '100%',
};
